import { ThemeInterface } from './styled';

let main_theme: ThemeInterface = {
    breakpoints: {
        sm: 700,
        md: 1365,
    },
    sizes: {
        general: {
            transition_time: 0.2,
            input_radius: 4,
            input_padding: '8px 12px',
        },
        padding: {
            horizontal: 16,
        },
        fonts: {
            big: 24,
            medium: 18,
            small: 14,
            tiny: 12,
        },
        panel: {
            height: 60,
        },
    },
    components: {
        left_panel: {
            shadow: '3px 0 10px 0 rgba(0,0,0,0.22)',
            width: 300,
        },
        right_panel: {
            shadow: '-3px 0 10px 0 rgba(0,0,0,0.22)',
            width: 400,
        },
        device_list: {
            sort_container: {
                height: 28,
            },
        },
        button: {
            radius: 3,
            shadow: '0px 3px 8px 0 rgba(0,0,0,0.42)',
            hover_shadow: '0px 11px 8px -4px rgba(0,0,0,0.42)',
            height: 40,
        },
        form: {
            user_input: {
                margin_bottom: 10,
            },
        },
        modal: {
            border_radius: 4,
        },
        formCard: {
            border_radius: 2,
            width: 450,
            glas_height: 160,
            glas_blur_margin: 20,
            top: 60,
        },
    },
    colors: {
        brand: ['#0A2E6E', '#1563EE', '#5D92F1', '#007CFF'],
        disabled_input: '#AAA',
        text: '#252424',
        border: '#CED9EE',
        background: '#E6E9F2',
        subtitle: '#97abbb',
        gray: ['#5C6778', '#B1C3DC', '#C0CFE3', '#E0E7F0'],
        dark: ['#2B344D', '#364161', '#3D496C', '#5C6778'],
        red: ['#bf392c', '#EB4D44', '#F47048', '#ff866b'],
        yellow: ['rgb(179, 141, 28)', 'rgb(231, 219, 60)', 'rgb(255, 253, 6)'],
        green: ['#32ab49', '#3fb742', '#57d547'],
        teal: ['#32ab49', '#3fb742', '#57d547'],
    },
    mixins: {
        truncate:
            'display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 95%;',
    },
};

export default main_theme;



// WEBPACK FOOTER //
// ./src/theme/main.ts